import { Component } from '@angular/core';

@Component({
    selector: 'app-components-admin-helptexteditor',
    templateUrl: './AdminHelpTextEditor.component.html'
})
export class AdminHelpTextEditorComponent {
}